import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { ItemLabel } from 'app/providers/storage-api/object-label.service';
import { ItemLabelComponent } from '../../../../../components/item-label/item-label.component';

@Component({
  selector: 'app-project-details-table-labels',
  imports: [AppSharedModule, ItemLabelComponent],
  templateUrl: './project-details-table-labels.component.html',
  styleUrls: ['./project-details-table-labels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDetailsTableLabelsComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() labels: ItemLabel[];
  @Input() projectItemType: string;

  private host: ElementRef<HTMLDivElement> = inject(ElementRef<HTMLDivElement>);
  private renderer = inject(Renderer2);
  private cdr = inject(ChangeDetectorRef);

  private tableResizeObserver: ResizeObserver;

  hiddenLabels = [];
  hiddenLabelsTooltip = '';

  ngOnInit(): void {
    this.tableResizeObserver = new ResizeObserver(() => this.renderLabels());
  }

  private renderLabels() {
    this.hiddenLabels = [];
    this.hiddenLabelsTooltip = '';

    const tags = this.host.nativeElement.querySelectorAll<HTMLDivElement>(
      '.project-item-label__pill'
    );
    tags.forEach((el) => this.renderer.removeStyle(el, 'display'));

    if (
      this.host.nativeElement.parentElement.scrollWidth >
      this.host.nativeElement.parentElement.offsetWidth
    ) {
      let idx = tags.length - 1;
      while (
        idx > -1 &&
        tags[idx].offsetLeft + tags[idx].offsetWidth >
          this.host.nativeElement.parentElement.offsetWidth - 70
      ) {
        this.renderer.setStyle(tags[idx], 'display', 'none');
        this.hiddenLabels.unshift(tags[idx--].textContent);
      }

      this.hiddenLabelsTooltip = this.hiddenLabels.join('\n');
    }

    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.labels && !changes.labels.isFirstChange()) {
      setTimeout(() => this.renderLabels());
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.tableResizeObserver.observe(this.host.nativeElement.parentElement));
  }

  ngOnDestroy(): void {
    this.tableResizeObserver?.disconnect();
  }

  labelTracker(label: ItemLabel): string {
    return label.id ?? label.type + ':' + label.label;
  }
}
